import * as React from 'react';

import type {
  PreviewVideoType,
  XdpHeroPreviewVideoVariant,
} from 'bundles/enroll-common/utils/previewVideoExperimentUtils';

export type PreviewVideoData = {
  /** The XDP product (courseId / s12nId) this preview video belongs to. */
  id: string;
  partner: string;
  name: string;
  type: 'Course' | 'S12N';
  thumbnailLink: string | null;
  duration?: string | null;
  /** Shell course + lecture item hosting the video, from the trailer mapping. */
  shellCourseId: string;
  itemId: string;
  videoType: PreviewVideoType;
  /** Committed poster image from the trailer mapping; wins over the video's own preview images. */
  posterSrc?: string;
};

export type PreviewVideoExperimentContextType = {
  experimentVariant: XdpHeroPreviewVideoVariant;
  loading: boolean;
  /** Ordered preview video playlist resolved for the current XDP. */
  previewVideos: PreviewVideoData[];
  productName: string;
  partnerLogoUrl: string | null;
  partnerName: string;
  rating: number | null;
  ratingCount: number | null;
  enrollmentCount: number | null;
  enrollButton: React.ReactNode;
  /** Call on hover/focus intent or actual open, so duration preloading can start as early as possible. */
  notifyPreviewVideoInterest: () => void;
};

const PreviewVideoExperimentContext = React.createContext<PreviewVideoExperimentContextType>({
  experimentVariant: 'control',
  loading: false,
  previewVideos: [],
  productName: '',
  partnerLogoUrl: null,
  partnerName: '',
  rating: null,
  ratingCount: null,
  enrollmentCount: null,
  enrollButton: null,
  notifyPreviewVideoInterest: () => {},
});

export const usePreviewVideoExperiment = () => {
  return React.useContext(PreviewVideoExperimentContext);
};

export default PreviewVideoExperimentContext;
